module.exports = __webpack_public_path__ + "img/tc.d40761f2.svg";